import { countries } from './countries';

function parsePostcodeSearchAddress(entry: Record<string, unknown>): Record<string, unknown> {
  const address = entry.address as Record<string, unknown> | undefined;
  const postcode = address?.postcode;
  const postcodeKey = typeof postcode === 'string' ? `fullAddress-${postcode}` : undefined;
  const rawValue = (postcodeKey ? entry[postcodeKey] : undefined) ?? address?.fullAddress;

  if (!rawValue) {
    return {};
  }

  if (typeof rawValue === 'object') {
    return rawValue as Record<string, unknown>;
  }

  return JSON.parse(String(rawValue));
}

export function hasCompleteAddressEntry(entry: Record<string, unknown>): boolean {
  const address = entry.address as Record<string, unknown> | undefined;

  if (!address?.postcode) {
    return false;
  }

  if (address.addressLine1) {
    return true;
  }

  return Boolean(parsePostcodeSearchAddress(entry).addressLine1);
}

// NOTE: this is used as AntD doesn't support transforms within a dependency valueType
export const transformAddress = (addressList: any, flatten = false) => {
  // Ensure we always work with an array
  const list = Array.isArray(addressList) ? addressList : [addressList];

  const transformedAddressList = list.map((entry: any) => {
    const transformedAddress = entry.address.isManual ? { ...entry.address } : { ...parsePostcodeSearchAddress(entry) };

    if (transformedAddress.townOrCity) {
      transformedAddress.town = transformedAddress.townOrCity;
      delete transformedAddress.townOrCity;
    }

    if (transformedAddress.country) {
      transformedAddress.countryCode = countries[transformedAddress.country.toLowerCase()]?.code || '';
    }

    delete transformedAddress.fullAddress;
    delete transformedAddress.isManual;

    // Apply flattening logic
    return flatten ? { ...transformedAddress } : { ...entry, address: transformedAddress };
  });

  // If input was a single object, return a single object
  return Array.isArray(addressList) ? transformedAddressList : transformedAddressList[0];
};
